<template>
  <component :is="reservationData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="reservationData === undefined">
      <h4 class="alert-heading">獲取預約卷數據時出錯</h4>
      <div class="alert-body">
        找不到相關預約卷記錄。請查看
        <b-link class="alert-link" :to="{ name: 'reservation-list' }">
          預約卷列表
        </b-link>
      </div>
    </b-alert>
    <reservation-edit-tab-information
      v-if="reservationData"
      :invoiceOptions="invoiceOptions"
      :customerOptions="customerOptions"
      :voucherStatusOptions="voucherStatusOptions"
      :reservation-data="reservationData"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import reservationStoreModule from "../reservationStoreModule";
import reservationEditTabInformation from "./reservationEditTabInformation.vue";

export default {
  components: {
    reservationEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const reservationData = ref({ id: 0 });
    const reservation = {
      id: 0,
    };

    const reservation_APP_STORE_MODULE_NAME = "reservation";

    if (!store.hasModule(reservation_APP_STORE_MODULE_NAME))
      store.registerModule(reservation_APP_STORE_MODULE_NAME, reservationStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(reservation_APP_STORE_MODULE_NAME))
        store.unregisterModule(reservation_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "coupon-reservation-create") {
        reservationData.value = reservation;
      } else {
        store
          .dispatch("reservation/fetchReservation", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            reservationData.value = response.data.reservation_voucher;
            console.log(reservationData.value);
          })
          .catch((error) => {
            console.log("error when fetching reservation", error);
            if (error.response.status === 404) {
              reservationData.value = undefined;
            }
          });
      }
    };

  const invoiceOptions = ref([]);
  const customerOptions = ref([]);
  const voucherStatusOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        invoices: true,
        customers: true,
        voucher_statuses:true,
      })
      .then((response) => {
        invoiceOptions.value = response.data.invoices;
        customerOptions.value = response.data.customers;
        voucherStatusOptions.value = response.data.voucher_statuses;
        refetchData();
      });
  };

    onMounted(() => {
      refetchOption();
    });

    return {
      reservationData,
      invoiceOptions,
      customerOptions,
      voucherStatusOptions,
      refetchOption,
      refetchData,
    };
  },
};
</script>
